<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="512" height="512">
    <!-- Clock face -->
    <path
        d="M12,24C5.383,24,0,18.617,0,12S5.383,0,12,0s12,5.383,12,12-5.383,12-12,12Zm0-22C6.486,2,2,6.486,2,12s4.486,10,10,10,10-4.486,10-10S17.514,2,12,2Z" />

    <!-- Clock hands -->
    <path [attr.d]="clockHandsPath" stroke="black" stroke-width="1.5" fill="none" stroke-linecap="round"
        stroke-linejoin="round" />
</svg>